export default {
      id: "report-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#report",
      toString: function () {
        return this.url;
      }
    }